export enum EmployeeSettingsTabTypes {
  GENERAL = 'general',
  CONNECTION_SETTINGS = 'connection_settings',
  IMPORT_MAPPINGS = 'import_mappings',
  AFAS_CONNECTORS = 'AFAS_connectors'
}

export type ImportEmployeeSetting = {
  valid: { from: string; to: string };
  accountFormat: string;
  apiPrefix: string;
  host: string;
  impEmployeeConfigId: number;
  user: `${number}`;
  startDate: string;
  brEmployerId?: number | number[];
};

export type EntityMap = {
  id: number;
  entity: string;
};

export type Entity = {
  id: number;
  type: EntityMap['entity'];
  propertyMappings: {
    internalName: string;
    externalName: string;
    flags: any[];
    endpoint?: null;
  }[];
};

export type Connector = {
  benefits: string;
  addresschanges: string;
  absences: string;
  salaries: string;
  travelarrangements: string;
  employees: string;
  hourmanagement: string;
};

export type Employeer = {
  brEmployerId: number;
  impEmployeeConfigId: number;
  impEmployeeConfigEmployerId: number;
};
